module.exports = __webpack_public_path__ + "img/imyanitov.4b3ca5e4.jpg";